'use strict';

var isArray = require('./isArray-fff5bad6.js');

function get(ks, o) {
  ks = isArray.isArray(ks) ? ks : ks.toString().split('.');
  return ks.reduce(function (a, k) {
    return a !== undefined ? a[k] : undefined;
  }, o);
}

module.exports = get;
